<template>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
      </div>
    </div>
  
    <div class="container-fluid py-3 mt-2">
      <!-- 🔹 제목 -->
      <div>
        <p class="custom-text-h4 font-weight-bold text-black ma-2">Material Scan</p>
        <p class="font-weight-bold ml-5 mt-0 text-gray">
          <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Material Management > Material Scan
        </p>
      </div>
  
      <!-- 🔹 검색 & 테이블 영역 -->
      <v-row class="d-flex align-items-center mb-1">
        <v-col cols="6" class="pr-2 pl-0 ml-3">
            <div class="split-box1">
                <div class="label-box">Scan Barcode</div>
                <div class="select-box">
                <v-text-field
                    ref="barcodeInput"
                    v-model="search.scanData"
                    placeholder="Scan Barcode here"
                    dense
                    outlined
                    class="custom-input mt-4"
                    variant="plain"
                    @keyup.enter="onBarcodeScanned"
                />
                </div>

                <!-- 🔸 이 아이콘을 클릭할 수 있게 수정 -->
                <div class="label-box2">
                <v-icon
                    left
                    color="primary"
                    class="cursor-pointer mr-2"
                    @click="getfilterData"
                    style="margin-left: 8px;"
                >
                    mdi-magnify
                </v-icon>
                </div>
            </div>
            </v-col>

            
            <v-col cols="3" class="d-flex align-center">


            <!-- 라벨 박스만 따로 -->
            <div class="label-box date-label-box ml-5">Date</div>

            <!-- date picker 2개 나란히 -->
            <div class="d-flex align-center mb-2" style="gap: 0px;" >
                <vue-datepicker 
                v-model="scanDate"
                class="custom-datepicker"
                placeholder="Start Date"
                :text-input="textInputOptions"
                :enable-time-picker="false"
                :max="date2"
                :auto-apply="true"
                format="yyyy-MM-dd"
                />
            </div>
            
          </v-col>

        <!-- <v-col cols="auto" class="d-flex justify-start ml-3">
            <v-btn color= "success" class="search-btn" @click="getfilterData">
                <v-icon left>mdi-magnify</v-icon> Search
            </v-btn>
        </v-col> -->
        <v-spacer />
        
        <v-col cols="auto" class="d-flex justify-end">
          <v-btn color="primary" class="search-btn" @click="getConfirm"     :disabled="items.length === 0">
            <v-icon left>mdi-check</v-icon> Confirm
          </v-btn>
        </v-col>
      </v-row>
  
      <v-card class="custom-card" elevation="2">
        <v-card-title class="custom-card-title">Scan Data</v-card-title>
        <div class="additional-content mt-3" style="padding-top: 3px;">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="-1"
            v-model:items-per-page="itemsPerPage"
            class="elevation-1 detail-table2 lift-up"
            height="60vh"
            density="compact"
            hover
            fixed-header
          >
            <template v-slot:bottom></template>
  
            <template #item="{ item }">
              <tr @click="openDetailPanel($event, { item })" style="cursor: pointer;">
                <td>{{ item.no }}</td> <!-- ✅ 순번 -->
                <td>{{ item.companyName }}</td>
                <td>{{ item.productNumber }}</td>
                <td>{{ item.productName }}</td>
                <td>{{ item.lotDate }}</td>
                <td class="font-weight-bold" style="text-align: right;">{{ formatNumber(item.quantity) }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { mapState } from "vuex";
  import "@vuepic/vue-datepicker/dist/main.css";
  import VueDatepicker from "@vuepic/vue-datepicker";
    

  export default {
    components: {
            VueDatepicker,
        },
    data() {
      return {
        lastScannedBarcode: null, // ✅ 마지막으로 검색한 바코드
        allowedCompanies: ['P0200', 'P0300', 'P1000', 'P1001', 'P2004'], // ✅ 신화, CNJ, 이화, 로지스올
        directWarehouseList: [], // ✅ Direct Warehouse 데이터 저장용
        scanDate: new Date(), // ✅ 기본값 오늘
        loading: false,
        date1: null,
        date2: null,
        search: {
          scanData: '',
        },
        textInputOptions: {
          openMenu: true,
          enterSubmit: true,
        },
        items: [],
        headers: [
          { title: "No", key: "no", align: "center", sortable: false },
          { title: "Company Name", key: "companyName", align: "center", sortable: false },
          { title: "Part Number", key: "productNumber", align: "center", sortable: false },
          { title: "Part Name", key: "productName", align: "center", sortable: false },
          { title: "LOT Date", key: "lotDate", align: "center", sortable: false },
          { title: "Quantity", key: "quantity", align: "center", sortable: false },
        ],
      };
    },
    mounted() {
        if (!this.allowedCompanies.includes(this.username)) {
            this.$router.push('/materialMain'); // ❗허용되지 않은 회사면 리다이렉트
        }
      this.$nextTick(() => {
        this.$refs.barcodeInput?.focus();
      });
      this.getDirectWarehouseList();

    },
    watch: {
      // 'search.scanData'(newVal) {
      //   if (newVal !== this.lastScannedBarcode) {
      //     this.lastScannedBarcode = null; // ✅ 수동으로 바꾸면 무효 처리
      //   }
      // }
    },
    computed: {
        ...mapState({
            username: (state) => state.username
        })
        },

    methods: {
      async getConfirm() {
        this.loading =true;
        if (this.items.length === 0) {
          alert("No scan data to confirm.");
          this.loading =false;
          return;
        }
        if (!this.scanDate) {
          alert("Please select the date.");
          this.loading =false;
          return;
        }
        if (!this.lastScannedBarcode || this.lastScannedBarcode.trim() === '') {
          alert("❌ Please scan a valid barcode first.");
          this.loading =false;
          return;
        }


        //console.log(this.items)
        try {
          const isSAUScan = this.search.scanData?.toUpperCase().startsWith("SAU");

          const apiUrl = isSAUScan
            ? "/api/updateTranspfForwarehouse"
            : "/api/updateTranspf";

          const response = await axios.post(apiUrl, {
            items: this.items,
            username: this.username,
            scanData: this.lastScannedBarcode,
            scanDate: this.formatDate(this.scanDate),
          });

          if (response.data.success) {
            alert("Successfully updated the transfer information!");
            this.items = []; // 완료 후 테이블 비우기
            this.search.scanData = '';
            this.lastScannedBarcode = null; // ✅ 처리 완료 후 초기화

          } else {
            alert("Failed to update transfer information. Please try again.");
          }
        } catch (error) {
          console.error("❌ updateTranspf API 호출 실패:", error);
          alert("Server error occurred. Please contact the administrator.");
        }
        this.loading = false;
      },

      async getDirectWarehouseList() {
          try {
            const response = await axios.get("/api/getDirectWarehouseList", {
              params: { username: this.username }
            });

            if (response.data.success) {
              //console.log("✅ Direct Warehouse List:", response.data.data);
              // 👉 데이터 저장 예시
              this.directWarehouseList = response.data.data;
            } else {
              console.error("❌ Direct Warehouse API 실패:", response.data.message);
            }
          } catch (error) {
            console.error("❌ getDirectWarehouseList 호출 오류:", error);
          }
        },
        formatItemNumber(rawItemNo) {
            const cleaned = rawItemNo.replace(/-/g, "");
            if (!isNaN(parseFloat(cleaned.charAt(0))) && isFinite(cleaned.charAt(0))) {
                return cleaned.substring(0, 5) + "-" + cleaned.substring(5);
            } else {
                return cleaned.substring(0, 6) + "-" + cleaned.substring(6);
            }
        },
      formatNumber(value) {
        if (!value) return "0";
        return Number(value).toLocaleString();
      },
      async getfilterData() {
        this.loading = true;
        //console.log('chekc', this.formatDate(this.scanDate))
        try {
          const isSAUScan = this.search.scanData?.toUpperCase().startsWith("SAU");

          // ✅ API URL 분기
          const apiUrl = isSAUScan 
              ? "/api/materialscandataFromwarehouse" 
              : "/api/materialscandata";

          console.log("📌 호출할 API:", apiUrl);

          const response = await axios.get(apiUrl, {
              params: {
                  barcode: this.search.scanData,
              }
          });

          if (response.data.success) {
            const { items, alreadyScanned } = response.data.items;
            // const { items } = response.data.items;

            const data = items;

            if (alreadyScanned) {
              alert('❗️These items have already been scanned.');
              this.items = [];
              return; // ⬅️ 바로 빠져나가야 함
            }

            if (data.length === 0) {
              alert("It is no valid scan data.");
              this.items = [];
              return;
            }

            // ✅ 변환 후 없는 품목 찾기
            const missingProducts = [];
            const tempItems = [];
            data.forEach((item) => {
              const formattedProductNumber = this.formatItemNumber(item.ITMNO).trim();

              if (this.directWarehouseList.some(d => d.ASDES?.toUpperCase() === formattedProductNumber.toUpperCase())) {
                tempItems.push({
                  no: tempItems.length + 1,
                  companyName: item.CO_GB,
                  productNumber: formattedProductNumber,
                  productName: item.ITM_NM,
                  lotDate: item.BOX_LOT,
                  quantity: item.BOX1_QTY,
                  ST_CUST_CD: item.ST_CUST_CD,
                  ORD_NO: item.ORD_NO

                });
              } else {
                if (!missingProducts.includes(formattedProductNumber)) {
                  missingProducts.push(formattedProductNumber);
                }
              }
            });
            this.lastScannedBarcode = this.search.scanData; // ✅ 스캔한 바코드 저장

            if (missingProducts.length > 0) {
              alert(`❗️ The following part numbers are not registered: ${missingProducts.join(", ")}\nPlease contact the material team.`);
              this.lastScannedBarcode = null;
              this.items = []; // ✅ 하나라도 없으면 items 비우기
            } else {
              this.items = tempItems; // ✅ 전부 문제없을 때만 테이블 표시
            }

          } else {
            console.error("❌ 바코드 조회 실패:");
            this.items = [];
            this.lastScannedBarcode = null;
          }
        } catch (error) {
          console.error("❌ 바코드 조회 실패:", error);
          this.items = [];
          this.lastScannedBarcode = null;
        } finally {
          this.loading = false;
        }
      },



      onBarcodeScanned() {

        if (this.search.scanData  && this.search.scanData .length > 0) {
          this.getfilterData();
        }
      },
      formatDate(date) {
        if (!date) return '';
        const d = new Date(date);
        return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
      },
    },
  };
  </script>
  
  <style scoped>
  .container-fluid {
    height: 92%;
    overflow-y: auto;
  }
  .custom-text-h4 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    text-transform: none !important;
  }
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  }
  .loading-container {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(0, 123, 255, 0.3);
    border-top: 5px solid #007bff;
    border-radius: 50%;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .loading-text {
    font-size: 64px;
    font-weight: bold;
    text-transform: uppercase;
    background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    color: transparent;
    animation: waveColor 3s ease-in-out infinite;
  }
  @keyframes waveColor {
    0% { background-position: 0% 70%; }
    50% { background-position: 100% 30%; }
    100% { background-position: 0% 70%; }
  }
  .split-box1 {
    display: flex;
    width: 80vh;
    height: 45px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    overflow: hidden;
    font-size: 16px;
  }
  .label-box {
    background-color: #f4f4f4;
    padding: 0 16px;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #374151;
    white-space: nowrap;
    border-right: 1px solid #d1d5db;
  }
  .label-box2 {
    background-color: #f4f4f4;
    padding: 0 5px;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #374151;
    white-space: nowrap;
    border-right: 1px solid #d1d5db;
    border-left: 1px solid #d1d5db;
  }
  .select-box {
    flex: 1;
    padding-left: 16px;
    display: flex;
    align-items: center;
    color: #374151;
    font-weight: bold;
    background-color: white;
  }
  .custom-card {
    width: 100%;
    height: 68vh;
  }
  .custom-card-title {
    background-color: #6ea6d9;
    color: white;
    font-weight: bold;
    font-size: 18px;
    padding: 6px 20px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    text-align: left;
    position: relative;
    z-index: 50 !important;
  }
  .additional-content {
    padding: 20px;
    font-size: 16px;
    color: #333;
  }
  :deep(.v-data-table thead th) {
    background-color: #e3f2fd !important;
    font-weight: bold !important;
    text-align: center;
  }
  :deep(.v-data-table tbody td) {
    font-size: 15px !important;
    font-weight: 500;
    text-align: center;
  }
  :deep(.v-data-table tbody td:nth-child(6)) {
    text-align: right !important;
  }

  :deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
:deep() .v-table .v-table__wrapper > table > tbody > tr > td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep(.v-data-table thead th:nth-child(1)) {
  width: 70px !important;
}

@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}
/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'hyundai' !important;
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5 !important; /* 짝수 행 연한 회색 */
}

:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: white !important; /* 홀수 행 흰색 */
}

.container-input3 {
    display: flex;
    align-items: center;
    background-color: white;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    font-size: 16px;
    width: 172px;
    height: 45px;
}
.date-label-box {
  background-color: #f4f4f4;
  height: 45px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border: 1px solid #d1d5db;
  border-radius: 4px 0 0 4px;
  border-right: none;
}
.custom-datepicker {
    width: 180px; /* 원하는 너비 조정 */
    height: 100px !important;
    border-radius: 0px;
    text-align: center;
    font-size: 14px;
    top: 31px
}
.custom-datepicker :deep(.dp__input) {
  height: 45px !important;
  font-size: 16px;
}
  </style>
  